{
    "items": [
        [true, 0, "lightgreen", "Actueel en vastgesteld RvB (2023-2026)"],
        [true, 0, "green", "Definitief / vastgesteld RvB (2019-2022)"],
        [true, 0, "purple", "Voorlopig"],
        [true, 0, "red", "Nog niet ingeleverd"]
    ],
    "title": "routekaart Ziekenhuizen"
}

